export const FeatureFlags = {
  BULK_UPDATE_ENABLED: 'bulk_updates_enabled',
  REMOVE_OPERATIONS_ENABLED: 'remove_ops_enabled',
  PATCH_EDIT_ENABLED: 'patch_edit_enabled',
  DEAL_LOVERS_ENABLED: 'deal_lovers_enabled',
  /** Named pricing: a store-level named price applied across products. Default OFF. */
  NAMED_PRICING_ENABLED: 'named_pricing_enabled',
  /**
   * Ranged topping/extra-cheese pricing. Default ON — turned off per environment only once that
   * environment's data has been migrated to named prices, and retired entirely in phase 3.
   */
  RANGED_PRICING_ENABLED: 'ranged_pricing_enabled',
  /**
   * Bulk exclusion reconcile: search one exclusion target across a store set, then add where missing and
   * remove where found. Default OFF. Gated behind PATCH_EDIT_ENABLED, since it stages the same pending
   * operations that inline editing does.
   */
  EXCLUSION_WORKFLOW_ENABLED: 'exclusion_workflow_enabled',
} as const;

export type FeatureFlagKey = typeof FeatureFlags[keyof typeof FeatureFlags];

export function isValidFeatureFlag(key: string): key is FeatureFlagKey {
  return Object.values(FeatureFlags).includes(key as FeatureFlagKey);
}

export default FeatureFlags;
